import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48745d88"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center mb-4"
}
const _hoisted_2 = { class: "text-center fw-bold mb-0 fs-5 pb-2" }
const _hoisted_3 = { class: "mb-2 d-flex justify-content-center" }

import Post from '@/views/shared/communities/components/Post.vue'
import CreatePostModal from '@/views/shared/communities/components/CreatePostModal.vue'
import EditPostModal from '@/views/shared/communities/components/EditPostModal.vue'
import LikeModal from '@/views/shared/communities/components/LikeModal.vue'
import InterestModal from '@/views/shared/communities/components/InterestModal.vue'
import InterestConfirmModal from '@/views/shared/communities/components/InterestConfirmModal.vue'
import CreateCommentModal from '@/views/shared/communities/components/CreateCommentModal.vue'
import DeleteCommentModal from '@/views/shared/communities/components/DeleteCommentModal.vue'
import DeleteCommentSuccessModal from '@/views/shared/communities/components/DeleteCommentSuccessModal.vue'
import DeletePostModal from '@/views/shared/communities/components/DeletePostModal.vue'
import DeletePostSuccessModal from '@/views/shared/communities/components/DeletePostSuccessModal.vue'
import NoPost from '@/views/shared/communities/components/NoPost.vue'
import PostSkeleton from '@/components/skeletons/PostSkeleton.vue'
import { translate } from '@/languages/i18n'

import { computed, ComputedRef, onMounted, onUnmounted, ref } from 'vue-demi'
import postService from '@/services/post.services'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { ACCOUNT_STORE, POST_STORE } from '@/store/constants'
import { Modal } from 'bootstrap'
import Button from '@/components/button/index.vue'
import { usePath } from '@/use/usePath'
import { POST_TYPE } from '@/constants/common'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()
const { path, id } = usePath()

const postsData = computed<ComputedRef>(() => store.getters[POST_STORE.GETTERS.POSTS])
const listUser = computed<ComputedRef>(() => store.getters[ACCOUNT_STORE.GETTERS.LIST_USER_WITH_DELETED])
const currentPostId = ref<string>()
const showModal = computed<ComputedRef>(() => store.getters[POST_STORE.GETTERS.POSTS]?.showModal)

const loadingLike = ref<boolean>(false)

const paramGetPost = ref()

const deleteTargetPostId = ref<string>()

const deleteTargetPostCommentId = ref<string>()

const deleteTargetCommentPublished = ref<boolean>()

const modalDeleteCommentSuccess = ref()
const commentIsDelete = ref(true)
const idComment = ref(null)
const interestConfirmModal = ref()

const setCurrentPost = (id: string) => {
  currentPostId.value = id
}

const getPosts = async () => {
  postsData.value.loadingPosts = true
  if (!route?.params?.id) return
  paramGetPost.value = {
    post_id: route?.params?.post_id,
    params: {
      target_content_id: route.query?.target_content_id,
    },
  }

  await store.dispatch(POST_STORE.ACTIONS.SET_POST_DETAIL, paramGetPost.value)
  postsData.value.loadingPosts = false
}

const getListUser = async () => {
  await store.dispatch(ACCOUNT_STORE.ACTIONS.SET_USER_WITH_DELETED, route?.params?.id)
}

const handleLikeOrInterest = async (type, post) => {
  loadingLike.value = true
  try {
    const likeOrInterestPostRes =
      type === 'interest'
        ? post.interest
          ? await postService.disInterestPost(post.id)
          : await postService.interestPost(post.id)
        : post.like
        ? await postService.disLikePost(post.id)
        : await postService.likePost(post.id)
    if (likeOrInterestPostRes.data?.success) {
      const newPost = postsData.value.posts.find((e) => e.id === post.id)

      newPost[`${type}_count`] = newPost[type] ? (newPost[`${type}_count`] ?? 0) - 1 : (newPost[`${type}_count`] ?? 0) + 1
      newPost[type] = !newPost[type]

      store.dispatch(POST_STORE.ACTIONS.UPDATE_POST, newPost)
      setTimeout(() => {
        loadingLike.value = false
      }, 500)
    }
  } catch (error) {
    console.log(error)
    loadingLike.value = false
  }
}

const back = (): void => {
  store.dispatch(POST_STORE.ACTIONS.REMOVE_ALL_POST)
  router.push(`/${path}/communities/${id}`)
}

const showDeleteCommentSuccessModal = (isDelete) => {
  commentIsDelete.value = isDelete
  modalDeleteCommentSuccess.value.show()
}

const showInterestConfirmModal = (post) => {
  interestConfirmModal.value.showDialog(post)
}

const setCommentData = (post_id, id, published) => {
  deleteTargetPostId.value = post_id
  deleteTargetPostCommentId.value = id
  deleteTargetCommentPublished.value = published
}

onMounted(() => {
  const elementDeleteCommentSuccessModal = document.getElementById('deleteCommentSuccess')
  modalDeleteCommentSuccess.value = new Modal(elementDeleteCommentSuccessModal)
  idComment.value = route.query?.target_content_id
})

onMounted(() => {
  getPosts()
  store.commit(POST_STORE.MUTATIONS.SET_POST_TYPE, POST_TYPE.DETAILS)
  getListUser()
})

onUnmounted(() => {
  store.commit(POST_STORE.MUTATIONS.REMOVE_ALL_POST)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(route).path.includes('admin'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)('postDetails')), 1)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(postsData).posts, (post) => {
      return (_openBlock(), _createElementBlock("div", {
        key: post.id
      }, [
        _createVNode(Post, {
          onSetCommentData: setCommentData,
          onSetCurrentPost: setCurrentPost,
          post: post,
          handleLikeOrInterest: handleLikeOrInterest,
          handleInterestClick: showInterestConfirmModal,
          loadingLike: loadingLike.value,
          isNotLoadingPostSkeleton: true,
          listUser: _unref(listUser),
          id_comment: idComment.value
        }, null, 8, ["post", "loadingLike", "listUser", "id_comment"])
      ]))
    }), 128)),
    (_unref(postsData).loadingPosts && _unref(showModal))
      ? (_openBlock(), _createBlock(PostSkeleton, { key: 1 }))
      : _createCommentVNode("", true),
    (!_unref(postsData).loadingPosts && _unref(postsData).posts?.length === 0 && !_unref(route).query?.keyword)
      ? (_openBlock(), _createBlock(NoPost, { key: 2 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Button, {
        title: _unref(translate)('back'),
        type: 'secondary',
        className: "mb-0 mb-lg-3 fw-bold",
        onClick: back
      }, null, 8, ["title"])
    ]),
    _createVNode(CreatePostModal),
    (currentPostId.value)
      ? (_openBlock(), _createBlock(EditPostModal, {
          key: 3,
          post: _unref(postsData).posts.find((e) => e.id === currentPostId.value)
        }, null, 8, ["post"]))
      : _createCommentVNode("", true),
    _createVNode(DeletePostModal, {
      postId: currentPostId.value,
      paramGetPost: paramGetPost.value
    }, null, 8, ["postId", "paramGetPost"]),
    _createVNode(DeletePostSuccessModal),
    _createVNode(InterestModal),
    _createVNode(InterestConfirmModal, {
      ref: (_value, _refs) => {
        _refs['interestConfirmModal'] = _value
        interestConfirmModal.value = _value
      },
      "on-confirm": (p) => handleLikeOrInterest('interest', p)
    }, null, 8, ["on-confirm"]),
    _createVNode(LikeModal),
    _createVNode(CreateCommentModal),
    _createVNode(DeleteCommentModal, {
      onShowDeleteCommentSuccessModal: showDeleteCommentSuccessModal,
      postId: deleteTargetPostId.value,
      postCommentId: deleteTargetPostCommentId.value,
      commentPublishedFlg: deleteTargetCommentPublished.value
    }, null, 8, ["postId", "postCommentId", "commentPublishedFlg"]),
    _createVNode(DeleteCommentSuccessModal, { "is-delete": commentIsDelete.value }, null, 8, ["is-delete"])
  ], 64))
}
}

})